class MCartAddons extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      zipCode: '[name="address[zip]"]',
      country: '[name="address[country]"]',
      shippingMessage: ".m-cart-addon__shipping-rate",
      calcShippingButton: ".m-cart-addon--calculate",
      triggerAddonButton: ".m-cart-addon--trigger-button",
      closeAddonButton: ".m-cart-addon--close",
    };

    this.cartWrapper =
      document.querySelector(".m-cart-drawer") ||
      document.querySelector(".m-cart__footer--wrapper");
    this.cartOverlay = this.cartWrapper.querySelector(".m-cart__overlay");
    this.openAddon = null;
    this.domNodes = this.queryDomNodes(this.selectors);

    this.init();
  }

  queryDomNodes(selectors) {
    const domNodes = {};
    for (const key in selectors) {
      domNodes[key] = this.cartWrapper.querySelector(selectors[key]);
    }
    return domNodes;
  }

  init() {
    this.initEvents();
    this.populateCountryList();
    this.setupCountrySearch();
    this.customizeTexts();
  }

  initEvents() {
    const { triggerAddonButton, closeAddonButton, calcShippingButton } =
      this.selectors;

    document.querySelectorAll(triggerAddonButton).forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        const section = button.dataset.open;
        const addon = this.cartWrapper.querySelector(`#m-addons-${section}`);
        if (addon) {
          addon.classList.add("open");
          this.cartOverlay.classList.add("open");
          this.openAddon = addon;
        }
      });
    });

    document.querySelectorAll(closeAddonButton).forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        if (this.openAddon) {
          this.openAddon.classList.remove("open");
          this.cartOverlay.classList.remove("open");
          this.openAddon = null;
        }
      });
    });

    const calcBtn = this.domNodes.calcShippingButton;
    if (calcBtn) {
      calcBtn.addEventListener("click", this.fakeCalcShipping.bind(this));
    }
  }

  populateCountryList() {
    const countries = [
      "Afeganistão",
      "África do Sul",
      "Alemanha",
      "Argentina",
      "Austrália",
      "Áustria",
      "Bélgica",
      "Bolívia",
      "Brasil",
      "Canadá",
      "Chile",
      "China",
      "Colômbia",
      "Coreia do Sul",
      "Dinamarca",
      "Egito",
      "Emirados Árabes Unidos",
      "Espanha",
      "Estados Unidos",
      "França",
      "Grécia",
      "Holanda",
      "Índia",
      "Indonésia",
      "Inglaterra",
      "Irlanda",
      "Israel",
      "Itália",
      "Japão",
      "Malásia",
      "México",
      "Noruega",
      "Nova Zelândia",
      "Panamá",
      "Paraguai",
      "Peru",
      "Polônia",
      "Portugal",
      "Reino Unido",
      "Rússia",
      "Singapura",
      "Suécia",
      "Suíça",
      "Tailândia",
      "Turquia",
      "Ucrânia",
      "Uruguai",
      "Venezuela",
      "Vietnã",
    ];

    const countrySelect = this.domNodes.country;
    if (countrySelect && countrySelect.options.length === 0) {
      countries.forEach((country) => {
        const option = document.createElement("option");
        option.value = country;
        option.textContent = country;
        countrySelect.appendChild(option);
      });
    }
  }

  setupCountrySearch() {
    const countrySelect = this.domNodes.country;
    if (countrySelect && !countrySelect.hasAttribute("data-search-enhanced")) {
      countrySelect.setAttribute("data-search-enhanced", "true");

      // Esconde o select para não aparecer na tela
      countrySelect.style.display = "none";

      // Cria input de busca (único campo visível)
      const searchInput = document.createElement("input");
      searchInput.placeholder = "Buscar país...";
      searchInput.style.marginBottom = "8px";
      searchInput.style.padding = "6px";
      searchInput.style.width = "100%";

      // Container para as opções filtradas
      const dropdown = document.createElement("div");
      dropdown.style.border = "1px solid #ddd";
      dropdown.style.maxHeight = "150px";
      dropdown.style.overflowY = "auto";
      dropdown.style.backgroundColor = "#fff";
      dropdown.style.position = "absolute";
      dropdown.style.width = searchInput.style.width;
      dropdown.style.zIndex = "1000";
      dropdown.style.display = "none";

      // Popula dropdown com opções
      const options = Array.from(countrySelect.options);

      function renderOptions(filter = "") {
        dropdown.innerHTML = "";
        const filtered = options.filter((opt) =>
          opt.text.toLowerCase().includes(filter.toLowerCase())
        );
        filtered.forEach((opt) => {
          const div = document.createElement("div");
          div.textContent = opt.text;
          div.style.padding = "6px";
          div.style.cursor = "pointer";
          div.addEventListener("mousedown", (e) => {
            e.preventDefault(); // Para evitar blur antes do click
            searchInput.value = opt.text;
            countrySelect.value = opt.value;
            dropdown.style.display = "none";
          });
          dropdown.appendChild(div);
        });
        dropdown.style.display = filtered.length ? "block" : "none";
      }

      searchInput.addEventListener("input", () => {
        renderOptions(searchInput.value);
        countrySelect.value = ""; // limpa o valor real até escolher opção
      });

      // Fechar dropdown se clicar fora
      document.addEventListener("click", (e) => {
        if (!searchInput.contains(e.target) && !dropdown.contains(e.target)) {
          dropdown.style.display = "none";
        }
      });

      // Insere input e dropdown no DOM
      countrySelect.parentNode.insertBefore(searchInput, countrySelect);
      countrySelect.parentNode.insertBefore(
        dropdown,
        countrySelect.nextSibling
      );

      // Inicializa dropdown vazio
      renderOptions();
    }
  }

  customizeTexts() {
    const labelZip = this.cartWrapper.querySelector('label[for="AddressZip"]');
    if (labelZip) labelZip.innerText = "CEP";

    const heading = this.cartWrapper.querySelector(".m-cart-addon__heading");
    if (heading) heading.innerText = "Estimativa de frete";

    const calcBtn = this.cartWrapper.querySelector(
      this.selectors.calcShippingButton
    );
    if (calcBtn) calcBtn.innerText = "Calcular";

    const provinceContainer = this.cartWrapper.querySelector(
      "#AddressProvinceContainer"
    );
    if (provinceContainer) provinceContainer.style.display = "none";
  }

  fakeCalcShipping(e) {
    e.preventDefault();

    const zip = this.domNodes.zipCode?.value?.trim();
    const country = this.domNodes.country?.value;
    const messageWrapper = this.domNodes.shippingMessage;

    if (!messageWrapper) return;

    messageWrapper.innerHTML = "";

    const box = document.createElement("div");
    box.style.border = "1px solid #ddd";
    box.style.borderRadius = "10px";
    box.style.padding = "16px";
    box.style.marginTop = "12px";
    box.style.backgroundColor = "#f9f9f9";

    const title = document.createElement("p");
    title.style.fontWeight = "bold";
    title.style.marginBottom = "8px";
    title.innerText = "Frete:";

    const row = document.createElement("div");
    row.style.display = "flex";
    row.style.alignItems = "center";
    row.style.gap = "10px";

    if (
      (country?.toLowerCase() === "brasil" ||
        country?.toLowerCase() === "brazil") &&
      zip
    ) {
      const logo = document.createElement("img");
      logo.src =
        "https://cdn.shopify.com/s/files/1/0588/3723/7822/files/correios2.png?v=1753768133";
      logo.alt = "Correios";
      logo.style.width = "110px";
      logo.style.height = "30px";

      const textContainer = document.createElement("div");
      textContainer.style.display = "flex";
      textContainer.style.flexDirection = "column";
      textContainer.style.alignItems = "flex-start"; // Alinha à esquerda, trocar para "center" para centralizar

      const valorRiscar = document.createElement("span");
      valorRiscar.innerHTML = `<del style='color: #888;'>R$ 16,72</del>`;

      const gratis = document.createElement("span");
      gratis.innerHTML = `<span style='color: green; font-weight: bold;'>Grátis</span>`;

      textContainer.appendChild(valorRiscar);
      textContainer.appendChild(gratis);

      row.appendChild(logo);
      row.appendChild(textContainer);
      box.appendChild(title);
      box.appendChild(row);
    } else if (country) {
      const freteText = document.createElement("span");
      const valor = (Math.random() * 50 + 30).toFixed(2).replace(".", ",");
      freteText.innerHTML = `<span style='color: #000;'>R$ ${valor}</span>`;
      row.appendChild(freteText);
      box.appendChild(title);
      box.appendChild(row);
    } else {
      box.innerText = "Selecione um país e preencha o CEP.";
    }

    messageWrapper.appendChild(box);
  }
}

customElements.define("m-cart-addons", MCartAddons);
